import { CreditUtilization } from "../Entities/CreditUtilization";
import apiClient from "./api.client.service";

class CreditService {
    private APIBaseUrl: string;

    constructor() {
        this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
    }

    // Method to get the credit utilization of the current organization
    async getCreditUtilization(): Promise<CreditUtilization[]> {
        try {
            const response = await apiClient.get(`${this.APIBaseUrl}/credit/utilizations`);
            return response.data || [];
        } catch (error: any) {
            console.error("🚀 ~ CreditService ~ getCreditUtilization ~ error:", error);
            return [];
        }
    }

    // Method to buy credits
    async buyCredits(quantity: number, userCurrency: "INR" | "USD") {
        try {
            const payload = {
                quantity,
                userCurrency
            }

            const response = await apiClient.post(`${this.APIBaseUrl}/credit/purchase`, payload);
            return response.data;

        } catch (error: any) {
            console.error("🚀 ~ CreditService ~ buyCredits ~ error:", error);
            return null;
        }
    }

    // Method to verify credit purchase payment
    async verifyCreditPayment(data: {
        razorpay_order_id: string;
        razorpay_payment_id: string;
        razorpay_signature: string;
        creditPlanId: string;
    }) {
        try {
            const payload = {
                orderId: data.razorpay_order_id,
                paymentId: data.razorpay_payment_id,
                signature: data.razorpay_signature,
                creditPlanId: data.creditPlanId,
            };

            const response = await apiClient.post(
                `${this.APIBaseUrl}/credit/verify-payment`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error: any) {
            console.error("🚀 ~ CreditService ~ verifyCreditPayment ~ error:", error);
            return null;
        }
    }
}

const creditService = new CreditService();

export default creditService;
